// extracted by mini-css-extract-plugin
export default {"btn":"ArrowBtn_btn__dN8ZR"};